export default __webpack_public_path__ + "static/media/check-o.106c6ca4.svg";